import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowForm, WorkflowProcess } from '../../types/generated.types';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkflowEditorApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-editor`;
  }

  async getWorkflowProcesses(): Promise<WorkflowProcess[]> {
    return await this.get<WorkflowProcess[]>('processes');
  }

  async getWorkflowForms(): Promise<WorkflowForm[]> {
    return await this.get<WorkflowForm[]>('forms');
  }

  async importWorkflow(workflowId: string, file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    const url = this.getUrl(`import/${workflowId}`);
    const options = { headers: { 'Content-Type': 'multipart/form-data' } };
    await firstValueFrom(this.httpClient.post(url, formData, options));
  }

  exportWorkflow(workflowId: string): void {
    this.download(`export/${workflowId}`);
  }  
}
